/** Encabezado de página de módulo. */
export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <header className="analytics-header">
      <div className="analytics-header-copy">
        {eyebrow ? <p className="analytics-eyebrow">{eyebrow}</p> : null}
        <h1 className="analytics-title">{title}</h1>
        {subtitle ? <p className="analytics-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="analytics-toolbar">{actions}</div> : null}
    </header>
  );
}
